import { ofType } from 'redux-observable';
import { from, Observable } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { getLoginRequestHeader } from '../../../utils';
import { of } from 'rxjs';
import { IAction } from '../../../helpers/interfaces';
import {
    checksumReportSuccess,
    ChecksumReportTypes,
} from '../../actions/backoffice/checksum-report-actions';
import { apiError } from '../../actions/user-actions';
import axios from 'axios';
import { SERVER_URL } from '../../../utils/config';

export const checksumReportEpic = (action$: Observable<IAction>) =>
    action$.pipe(
        ofType(ChecksumReportTypes.CHECKSUM_REPORT_REQUEST),
        mergeMap((action) => {
            const params = new URLSearchParams();

            if (action.payload?.pagingInfo) {
                const { pageNumber, pageSize, sortBy, order } = action.payload.pagingInfo;
                params.append('pageNumber', (pageNumber ?? 1).toString());
                params.append('pageSize', (pageSize ?? 10).toString());
                if (sortBy) params.append('sortBy', sortBy);
                if (order) params.append('order', order);
            }

            if (action.payload?.algorithmType) {
                const algo = action.payload.algorithmType;
                if (Array.isArray(algo)) {
                    algo.forEach((a: string) => params.append('hashingAlgorithm', a));
                } else {
                    params.append('hashingAlgorithm', algo);
                }
            }

            if (action.payload?.search) {
                params.append('search', action.payload.search);
            }

            const url = `${SERVER_URL}/game-certified-hash?${params.toString()}`;

            return from(
                axios.get(url, {
                    headers: getLoginRequestHeader('application/json'),
                }),
            ).pipe(
                map((response) => checksumReportSuccess(response.data)),
                catchError((error) =>
                    of(apiError(error, ChecksumReportTypes.CHECKSUM_REPORT_REQUEST)),
                ),
            );
        }),
    );
